import { HatchProfileFormData } from "@/types/hatchProfile";
import { getCompanyId } from '@/utils/getCompanyId'

const mapHatchProfileToApiProfile = (
	formData: HatchProfileFormData
): any => {

	const company_id = getCompanyId() || '';


	return {
		id: formData.id,
		name: formData.name,
		description: formData.description,
		company_id,

		hatch_patterns: (formData.hatch_patterns || []).map((p) => ({
			id: p.id,
			laser_profile_id: p.laser_profile_id?.value,

			hatch_type: p.hatch_type?.value,
			hatch_style: p.hatch_style?.value,

			border_gap: Number(p.border_gap),
			is_apply_smoothing: !!p.is_apply_smoothing,
			with_offset: !!p.with_offset,

			border_gap_direction: p.border_gap_direction?.value,
			corner_style: p.corner_style?.value,

			line_gap: Number(p.line_gap),
			line_angle: Number(p.line_angle),

			base: {
				x: Number(p.base_x),
				y: Number(p.base_y),
			},

			individual_hatch_line_repeat_count: Number(
				p.individual_hatch_line_repeat_count
			),

			is_incremental_rotation_enabled: !!p.is_incremental_rotation_enabled,

			incremental_start_angle: Number(p.incremental_start_angle),
			incremental_step_angle: Number(p.incremental_step_angle),
			incremental_step_count: Number(p.incremental_step_count),
		})),
	};
};


export default mapHatchProfileToApiProfile